export const riskManagementFiltersArticle = {
  title: 'Risk Management: Filters & Mitigation Tracking',
  slug: 'risk-management-filters',
  content: `Risk Management: Filters & Mitigation Tracking

Use filters and AI mitigation tools to stay on top of exposure.

1) Filter the register
- Open Filters to filter by source, level, mitigation status, and risk score range.
- Use sort options to prioritize high-risk items.

2) Review summary cards
- Summary highlights overall exposure and risk counts.

3) Generate mitigation strategies
- Provide a title and description for a risk.
- Use the AI action to generate mitigation suggestions.

4) Update status
- Set mitigation status and deadlines as plans progress.
`,
};
